import "../ProductCategoryModal/ProductCategoryModal.scss";
import primaryComponents from "../../primaryComponents";
import useUpdateCreditLogLogic from "./useUpdateCreditLogLogic";
import Validation from "./useValidation";
import { CreditLimitIcon } from "../../../assets/svgIcons";
import { convertToTilteCase, formatCurrency } from "../../../helpers";
import { useStoreCurrency } from "../../../hooks/useStoreCurrency";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import secondaryComponents from "..";

const UpdateCreditLogModal = ({
  orderAmount = 0,
  customer,
  onSuccess = () => {},
  closeModal = () => {},
  type = "credit",
}) => {
  const { store_currency } = useStoreCurrency();

  const {
    creditLimit,
    isUpdating,
    customerDetails,
    isLoadingCustomerDetails,
    setCreditLimit,
    updateCreditLimitById,
  } = useUpdateCreditLogLogic({ customer, closeModal, onSuccess });

  const {
    register,
    formState: { errors },
    trigger,
    control,
    handleSubmit,
  } = Validation();

  return (
    <div className="p-3">
      <secondaryComponents.LoaderHelper
        classNames={"mt-5"}
        isLoading={isLoadingCustomerDetails}
      >
        {type === "credit" ? (
          <h5 className="font-weight-semibold text-center">
            Edit Credit limit for this customer
          </h5>
        ) : (
          <div>
            <CreditLimitIcon />
            <p className="orange--text">
              {convertToTilteCase(customerDetails?.full_name)} exceeds his/her
              credit limit for this transaction
            </p>

            <div className="mt-2">
              <h6>
                Order Amount:
                <span className="gray--text ml-2">
                  {formatCurrency({
                    value: orderAmount,
                    currencyCode: store_currency,
                  })}
                </span>
              </h6>
              <h6>
                Current Credit Limit:
                <span className="gray--text ml-2">
                  {formatCurrency({
                    value: customerDetails?.credit_limit,
                    currencyCode: store_currency,
                  })}
                </span>
              </h6>
              <h6>
                Outstanding Debt Balance:
                <span className="gray--text ml-2">
                  {formatCurrency({
                    value: customerDetails?.outstanding_balance,
                    currencyCode: store_currency,
                  })}
                </span>
              </h6>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit(updateCreditLimitById)} className="mt-4">
          <primaryComponents.AmountFieldV2
            control={control}
            classNames="white"
            name="creditLimit"
            label={
              type === "credit"
                ? "Set Credit Limit"
                : "Update Customer's Credit Limit to Proceed"
            }
            currency_code={customer?.store?.currency_code}
            isRequired={true}
            value={creditLimit}
            placeholder={"Edit Credit limit for this customer"}
            onChange={({ target: { value } }) => {
              setCreditLimit(value);
            }}
            errorMessage={errors.creditLimit}
            onKeyUp={() =>
              errors.creditLimit !== undefined && trigger("creditLimit")
            }
            register={register}
          />

          <div className={`${globalStyles.bottomButtonCover} mt-4`}>
            <primaryComponents.Button
              classNames={"btn btn--outline cover"}
              type="button"
              onClick={() => closeModal()}
            >
              Cancel
            </primaryComponents.Button>

            <primaryComponents.Button
              classNames={"btn btn--primary cover"}
              isLoading={isUpdating}
              isDisabled={isUpdating}
              loadingText="Updating..."
              type="submit"
            >
              Update Credit Limit
            </primaryComponents.Button>
          </div>
        </form>
      </secondaryComponents.LoaderHelper>
    </div>
  );
};
export default UpdateCreditLogModal;
